<template>
    <div class="progress-circle"  :style="coverSize">
        <template v-if="!empty">
            <svg :width="size" :height="size">
                <circle class="static-circle" :r="size / 2 - stokeWidth / 2" :cx="size/2" :cy="size/2" fill="none" :stroke-width="stokeWidth"></circle>
                <path class="progress-indicator" v-show="progress" :d="path" fill="none" :stroke-width="stokeWidth" :stroke-linecap="linecap" ></path>
            </svg>
            <h2 v-if="!isNaN(value)" class="value">{{value}}</h2>
        </template>
        <h2 v-else class="value">K/D</h2>
    </div>
</template>

<script>
    export default {
        name: "progress_circle",
        props:{
            progress: Number,
            size: Number,
            stokeWidth: Number,
            background: String,
            empty: Boolean,
            roundLineCap: {
              type: Boolean,
              default: false,
            },
            value: {
                type: Number,
                required: false,
            }
        },
        computed:{
            path(){
                let fix = 0.999; // 1
                let progress = this.progress>fix ? fix : this.progress;
                let center = this.size / 2;
                return this.describeArc(center, center, center - this.stokeWidth / 2, 0, progress * 360);
            },
            linecap(){
                return this.roundLineCap? "round" : "inherit"
            },
            coverSize(){
                return {
                    width: this.size + 'px',
                    height: this.size + 'px',
                    background: this.background,
                }
            }
        },
        methods:{
            polarToCartesian(centerX, centerY, radius, angleInDegrees) {
                let angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
                return {
                    x: centerX + (radius * Math.cos(angleInRadians)),
                    y: centerY + (radius * Math.sin(angleInRadians))
                };
            },
            describeArc(x, y, radius, startAngle, endAngle){
                let start = this.polarToCartesian(x, y, radius, endAngle);
                let end = this.polarToCartesian(x, y, radius, startAngle);
                let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
                return [
                    "M", start.x, start.y,
                    "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
                ].join(" ");
            }

        }
    }
</script>

<style scoped lang="scss">
    .progress-circle {
        position: relative;
        border-radius: 50%;

        .value {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin-bottom: 0 !important;
        }
        @include tablet{
            .value{
                font-size: 18px !important;
            }
        }
    }
</style>